 <!-- eslint-disable vue/valid-v-model -->
 <!-- eslint-disable vue/no-unused-vars-->
 
<template>
  <div class="card">
    <!-- <BlockUI >
      <ProgressSpinner v-if="blockedDocument" />
    </BlockUI> -->
     <!-- <div v-if="blockedDocument">
            <LoadingArete />
        </div> -->
    <div >
    <DataTable
      :value="applications"
      class="p-datatable p-datatable-striped"
      :paginator="true"
      sortField="createdDate" 
      :sortOrder="-1"
      :lazy="true"
      :rows="pageSize"
      :totalRecords="totalItemsCount" 
      @page="onPage($event)"
      @sort="onSort($event)"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[10, 25, 50]"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      dataKey="id"
      :rowHover="true"
      :filters="filters"
      selectionMode="single"
      removableSort
      :loading="loading"
    >
      <template #header>
        <div class="table-header">
         <h5> Applications </h5>
          <Button v-if="hasAdminRights"
            label="New Application"
            icon="pi pi-plus"
            class="p-button-secondary p-mr-2"
            @click="openappDialog()"
          /> <Button v-else
            label="New Application"
            icon="pi pi-plus"
            class="p-button-secondary p-mr-2"
            @click="openappReqDialog('Add New Application')"
          />
        </div>
      </template>
      <template #empty> No Application found. </template>
      <Column
        field="name"
        header="Name"
        sortable
        filterMatchMode="contains"
        class="p-col"
      >
        <template #filter>
          <InputText
            type="text"
            v-model="filters['name']"
            class="p-column-filter"
            placeholder="Search by Name"
            v-on:input="filterSearch('name')"
          />
        </template>
      </Column>
      <Column
        field="description"
        header="Description"
        sortable
        filterMatchMode="contains"
        class="p-col"
      >
        <template #filter>
          <InputText
            type="text"
            v-model="filters['description']"
            class="p-column-filter"
            placeholder="Search by Description"
            v-on:input="filterSearch('description')"
          />
        </template>
      </Column>
      <Column
        field="createdBy"
        header="CreatedBy"
        sortable
        filterMatchMode="contains"
        class="p-col"
      >
        <template #filter>
          <InputText
            type="text"
            v-model="filters['createdBy']"
            class="p-column-filter"
            placeholder="Search by CreatedBy"
            v-on:input="filterSearch('createdby')"
          />
        </template>
      </Column>
      <Column
        field="createdDate"
        header="CreatedDate"
        sortable
        filterMatchMode="custom"
        :filterFunction="filterDate"
        class="p-col"
      >
        <template #body="slotProps">
          {{ slotProps.data.createdDate | formatDateTime }}
        </template>
        <template #filter>
          <Calendar
            v-model="filters['createdDate']"
            dateFormat="dd/mm/yy"
            class="p-column-filter"
            placeholder="Created Date"
            :manualInput="false"
            :showButtonBar="true"
            :showClear="true"
            v-on:input="filterSearch('createddate')"
          />
        </template>
      </Column>
      <Column
        field="isActive"
        header="Status"
        sortable
        filterMatchMode="custom"
        :filterFunction="filterStatus"
      >
        <template #body="slotProps">
          <span
            :class="
              'customstatus ' +
              (slotProps.data.isActive ? 'Active' : 'Inactive').toLowerCase()
            "
            >{{ slotProps.data.isActive ? "Active" : "Inactive" }}</span
          >
        </template>
        <template #filter>
          <Dropdown
            v-model="filters['isActive']"
            :options="statuses"
            placeholder="Select a Status"
            class="p-column-filter"
            :showClear="true"
            @change="filterSearch('status')"
          >
            <template #option="slotProps">
              <span :class="'customstatus ' + slotProps.option.toLowerCase()">{{
                slotProps.option
              }}</span>
            </template>
          </Dropdown>
        </template>
      </Column>
      <Column header="Actions" class="p-col">
        <template #body="slotProps">
          <Button v-if="hasAdminRights"
            icon="pi pi-pencil"
            class="p-button-rounded p-button-secondary p-mr-2"
            @click="editApplication(slotProps.data)"
            v-tooltip.bottom="'Edit application / reviewers / publishers'"
          />
          <Button v-else
            icon="pi pi-pencil"
            class="p-button-rounded p-button-secondary p-mr-2"
            @click="openappReqDialog('Edit Application')"
            v-tooltip.bottom="'Edit application / reviewers / publishers'"
          />
          <Button
            v-if="slotProps.data.isActive && hasAdminRights"
            icon="pi pi-ban"
            class="p-button-rounded p-button-secondary p-mr-2 inactive"
            @click="opendeleteDialog(slotProps.data)"
            v-tooltip.bottom="'Deactivate Application'"
          />
          <Button
            v-if="slotProps.data.isActive && !hasAdminRights"
            icon="pi pi-ban"
            class="p-button-rounded p-button-secondary p-mr-2 inactive"
            @click="openappReqDialog('Deactivate Application')"
            v-tooltip.bottom="'Deactivate Application'"
          />
          <Button
            v-if="!slotProps.data.isActive && hasAdminRights"
            icon="pi pi-check"
            class="p-button-rounded p-button-secondary p-mr-2 active"
            @click="openundoDialog(slotProps.data)"
            v-tooltip.bottom="'Activate Application'"
          />
          <Button
            v-if="!slotProps.data.isActive && !hasAdminRights"
            icon="pi pi-check"
            class="p-button-rounded p-button-secondary p-mr-2 active"
            @click="openappReqDialog('Activate Application')"
            v-tooltip.bottom="'Activate Application'"
          />
          <Button
            icon="pi pi-users"
            class="p-button-rounded p-button-info"
            @click="viewReviewersPublishers(slotProps.data)"
            v-tooltip.bottom="'View reviewers & publishers'"
          />
        </template>
      </Column>
    </DataTable>
      </div>
    <Dialog
      :visible.sync="appDialog"
      header="Application Configuration with Reviewers & Publishers"
      :modal="true"
      :contentStyle="{ overflow: 'visible' }"
      :style="{ width: '50vw' }"
    >
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-12">
          <label for="appName"
            >Name<span class="p-invalid">*</span
            >
          </label>
          <InputText
            v-model="applicationDetails.name"
            id="appName"
            type="text"
            placeholder="Application Name"
            required="true"
            :class="{ 'p-invalid': (submitted && !applicationDetails.name) || (IsEditMode && !applicationDetails.name) }"
          />
          <span
              :class="{ 'p-invalid': !applicationDetails.name }"
              v-if="(submitted && !applicationDetails.name) || (IsEditMode && !applicationDetails.name)"
              class="error-message"
              >Application Name is Required</span
            >
        </div>
        <!-- <div class="p-field p-col-12 p-md-12">
          <label for="appTitle"
            >Title<span class="p-invalid">*</span
            ></label
          >
          <InputText
            v-model="applicationDetails.title"
            id="appTitle"
            type="text"
            placeholder="Application Title"
            required="true"
            :class="{ 'p-invalid': submitted && !applicationDetails.title }"
          />
          <span
              :class="{ 'p-invalid': !applicationDetails.title }"
              v-if="submitted && !applicationDetails.title"
              class="error-message"
              >Application Title is Required</span
            >
        </div> -->
        <div class="p-field p-col-12">
          <label for="appDescription"
            >Description<span class="p-invalid">*</span
            ></label
          >
          <Textarea
            :autoResize="true"
            rows="3"
            cols="7"
            placeholder="Application Description"
            required="true"
            v-model="applicationDetails.description"
            :class="{ 'p-invalid': (submitted && !applicationDetails.description) || (IsEditMode && !applicationDetails.description) }"
          />
          <span
              :class="{ 'p-invalid': !applicationDetails.description }"
              v-if="(submitted && !applicationDetails.description) || (IsEditMode && !applicationDetails.description)"
              class="error-message"
              >Application Description is Required</span
            >
        </div>
        <div class="p-field p-col-12">
          <label for="reviewers" v-if="IsEditMode"
            >Reviewers<span class="p-invalid">*</span
            ><span :class="{ 'p-invalid': !applicationDetails.reviewers.length!=0 }"
              v-if="submitted && !applicationDetails.reviewers.length!=0"
              >Application Reviewers are Required</span
            ></label>
            
            <label for="reviewers" v-else
            >Reviewers<span class="p-invalid">*</span
            ></label>
          <AutoComplete
            v-model="applicationDetails.reviewers"
            :suggestions="filteredUsers"
            @complete="searchUsers($event)"
            @item-unselect="revalidateReviewer($event)"
            field="name"
            :multiple="true"
            required="true"
            :class="{ 'p-invalid':(!applicationDetails.skipApproval && ((submitted && !applicationDetails.reviewers) || (IsEditMode && !applicationDetails.reviewers)))}"
            appendTo="body"
          >
            <template #item="slotProps">
              <div>{{ slotProps.item.name }}</div>
              <div>{{ slotProps.item.email }}</div>
            </template>
          </AutoComplete>
          <span :class="{ 'p-invalid': !applicationDetails.reviewers }"
              v-if="(!applicationDetails.skipApproval && ((submitted && !applicationDetails.reviewers) || (IsEditMode && !applicationDetails.reviewers)))"
              class="error-message"
              >Application Reviewers are Required</span
            >
        </div>
        <div class="p-field-checkbox p-col-12">
            <Checkbox id="binary" v-model="applicationDetails.skipApproval" :binary="true" @change="onSkipApproval($event)" />
            <label for="binary" style="margin-top: 7px">Skip Approval</label>
        </div>
        <div class="p-field p-col-12">
                  <label for="publishers" v-if="IsEditMode"
            >Publishers<span class="p-invalid">*</span
            ></label>
          <label for="publishers" v-else
            >Publishers<span class="p-invalid">*</span
            ></label>
          <AutoComplete
            v-model="applicationDetails.publishers"
            :suggestions="filteredUsers"
            @complete="searchUsers($event)"
            @item-unselect="revalidatePublisher($event)"
            field="name"
            :multiple="true"
            required="true"
            appendTo="body"
            :class="{ 'p-invalid':(!applicationDetails.skipApproval && ((submitted && !applicationDetails.publishers) || (IsEditMode && !applicationDetails.publishers))) }"
          >
            <template #item="slotProps">
              <div>{{ slotProps.item.name }}</div>
              <div>{{ slotProps.item.email }}</div>
            </template>
          </AutoComplete>
          <span
              :class="{ 'p-invalid': !applicationDetails.publishers }"
              v-if="(!applicationDetails.skipApproval && ((submitted && !applicationDetails.publishers) || (IsEditMode && !applicationDetails.publishers)))"
              class="error-message"
              >Application Publishers are Required</span
            >
        </div>
      </div>
      <template #footer>
        <Button
          label="Save Application"
          icon="pi pi-check"
          class="p-button-text"
          @click="saveApplication()"
        />
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-text"
          @click="closeDialog()"
        />
      </template>
    </Dialog>
    <Dialog
      v-if="viewUsers"
      :visible.sync="viewUsers"
      :header="selectedApplication.dialogHeader"
      :modal="true"
      :contentStyle="{ overflow: 'visible' }"
      :style="{ width: '50vw' }"
      ref="viewReviewersPublishers"
    >
      <div class="p-fluid p-grid">
        <Card class="p-col mr-4" style="margin-bottom: 2em">
          <template slot="title">{{
            `Reviewers of ${selectedApplication.name}`
          }}</template>
          <template slot="content">
            <p
              v-for="reviewer in selectedApplication.reviewers"
              v-bind:key="reviewer.userId"
            >
              <span class="mr-3">{{ reviewer.name }}</span
              ><span>{{ reviewer.email }}</span>
            </p>
          </template>
        </Card>
        <Card class="p-col" style="margin-bottom: 2em">
          <template slot="title">{{
            `Publishers of ${selectedApplication.name}`
          }}</template>
          <template slot="content">
            <p
              v-for="publisher in selectedApplication.publishers"
              v-bind:key="publisher.userId"
            >
              <span class="mr-3"> {{ publisher.name }}</span
              ><span>{{ publisher.email }}</span>
            </p>
          </template>
        </Card>
      </div>
      <template #footer>
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-text"
          @click="closeDialog()"
        />
      </template>
    </Dialog>
    <Dialog
      v-if="deleteApp"
      :visible.sync="deleteApp"
      header="Confirmation"
      :modal="true"
      :style="{ width: '30vw' }"
    >
      <div class="p-fluid p-grid">
        <div class="confirmation-content">
         
          <span>{{ selectedApplication.dialogContent }}</span>
        </div>
      </div>
      <template #footer>
        <Button
          label="No"
          icon="pi pi-times"
          @click="closeDialog()"
          class="p-button-text"
        />
        <Button
          label="Yes"
          icon="pi pi-check"
          @click="updatestatus()"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>

    <Dialog
      :visible.sync="reqToAddAppDialogue"
      header="Access Forbidden"
      :modal="true"
      :style="{ width: '30vw' }"
    >
      <div class="p-fluid p-grid">
        <div class="confirmation-content" style="color:darkorange; font-variant:all-small-caps;">
          <i
            class="pi pi-exclamation-triangle p-mr-3"
            style="font-size: 2rem"
          />
          <span>You don't have enough permission to {{dialogueTxt}}. 
            </span><br><br>
            <span>Kindly Contact your Administrator for more details.</span>
            <div></div>
        </div>
      </div>
      <template #footer>
        <Button
          label="Close"
          icon="pi pi-times"
          @click="closeDialog()"
          class="p-button-text"
        />
        
      </template>
    </Dialog>
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";
export default {
  name: "applicationsComponents",
  watch: {},
  data() {
    return {
      blockedPanel: false,
      blockedDocument: false,
      applications: null,
      appDialog: false,
      reqToAddAppDialogue: false,
      applicationDetails: {},
      filteredUsers: null,
      filters: {},
      submitted: false,
      loading: false,
      expandedRows: [],
      originalRows: null,
      viewUsers: false,
      selectedApplication: null,
      deleteApp: false,
      statuses: ["Active", "Inactive"],
      form_error: false,
      IsEditMode: false,
      toastsummary: "Saved Application",
      hasAdminRights : null,
      dialogueTxt: null,
      totalItemsCount: null,
      pageSize : 10,
      selectedPageNo : null,
      selectedPageSize: null,
      appliedFilters: null,
      skipApproval: false,
    };
  },
  created() {
    let input = {
      startPageNo : 1,
      recordsPerPage : this.pageSize,
      sortOrder: {
          columnName: "createdDate",
          direction: 1,
        },
    }
    this.getApplications(input);
  },
  mounted() {},
  methods: {
    filterSearch(ctrl){
      // console.log(ctrl);
      setTimeout(() => this.onPage(ctrl), 1000);
    },
   onSort(event) {
      setTimeout(() => this.onPage(event), 1000);
    },
    onPage(event) {
            this.loading = true;
            // console.log(event);
            let input = {
              startPageNo : event.page ? event.page + 1  : 1,
              recordsPerPage : event.rows ? event.rows : this.pageSize,
              filters : {
                title : this.filters.title == undefined ? null : this.filters.title,
                name : this.filters.name == undefined ? null : this.filters.name,
                description : this.filters.description == undefined ? null : this.filters.description,
                createdBy : this.filters.createdBy == undefined ? null : this.filters.createdBy,
                createdDate : this.filters.createdDate == undefined ? null : this.filters.createdDate,
                status : this.filters.isActive == undefined ? null : this.filters.isActive == "Active" ? true : false,
              },
              sortOrder: {
                columnName: event.sortField ? event.sortField : "createdDate",
                direction: event.sortOrder ? event.sortField != "isActive" ? (event.sortOrder == 1 ? 0 : 1) : (event.sortOrder == 1 ? 1 : 0) : 1,
              },
            }
            this.selectedPageNo = input.startPageNo ? input.startPageNo : 1 ;
            this.selectedPageSize = input.recordsPerPage ? input.recordsPerPage : this.pageSize;
           
             this.getApplications(input); 
      },
    getApplications(input) {
      let that = this;
      this.loading = true;
      this.blockedDocument = true;
      this.$store
        .dispatch("application/getApplications",input)
        .then((response) => {
          that.$root.$emit('defaultComp');
          that.applications =
            that.$store.getters["application/getApplications"];
            that.totalItemsCount = that.applications.totalRecords;
            //that.pageSize = that.applications.pageNo;
            console.log(response);
          let loggedUser = JSON.parse(localStorage.getItem('user'));
          that.hasAdminRights = loggedUser.hasAdminRights;
          that.blockedDocument = false;
          that.closeDialog();
        })
        .catch((error) => {
          this.$toast.add({
            severity: "error",
            summary: "Error while fetching applications",
            detail: error,
            life: 3000,
          });
          that.blockedDocument = false;
        });
    },

    validateFrom() {
      this.form_error = false;
      let app = this.applicationDetails;
      if (this.IsEditMode && !app.skipApproval) {
        this.form_error = app.publishers.length > 0 && app.reviewers.length > 0 && !_.includes(app, "")
      } else if((this.IsEditMode || !this.IsEditMode) && app.skipApproval){
        this.form_error = !_.includes(app, "");
      } else if (Object.keys(app).length >= 4 && app.name != "" && app.description != "" && app.publishers.length != 0 && app.reviewers.length !=0 && !this.IsEditMode ) {
        this.form_error = true;
      }
    },

    openappDialog() {
      this.applicationDetails = {};
      this.appDialog = true;
      this.IsEditMode=false;
    },
    openappReqDialog(str) {
      this.applicationDetails = {};
      this.reqToAddAppDialogue = true;
      this.dialogueTxt = str;
    },

    closeDialog() {
      this.blockedDocument = false;
      this.IsEditMode = false;
      this.appDialog = false;
      this.submitted = false;
      this.viewUsers = false;
      this.deleteApp = false;
      this.loading = false;
      this.applicationDetails = {};
      this.selectedApplication = null;
      this.reqToAddAppDialogue = false;
    },

    getCurrentPagedApplications(){
      this.appliedFilters = this.filters;
      let currentReq = {
              startPageNo : this.selectedPageNo ? this.selectedPageNo : 1,
              recordsPerPage : this.selectedPageSize ? this.selectedPageSize : this.pageSize,
              filters : this.appliedFilters ? {
                title : this.appliedFilters.title == undefined ? null : this.appliedFilters.title,
                name : this.appliedFilters.name == undefined ? null : this.appliedFilters.name,
                description : this.appliedFilters.description == undefined ? null : this.appliedFilters.description,
                createdBy : this.appliedFilters.createdBy == undefined ? null : this.appliedFilters.createdBy,
                createdDate : this.appliedFilters.createdDate == undefined ? null : this.appliedFilters.createdDate,
                status : this.appliedFilters.isActive == undefined ? null : this.appliedFilters.isActive == "Active" ? true : false,
              } : null,
              sortOrder: {
                columnName: "createdDate",
                direction: 1,
              },
            }
            this.getApplications(currentReq);
    },

    searchUsers(event) {
      let that = this;
      if (!event.query.trim().length) {
        return;
      } else {
        this.$store
          .dispatch("application/getUsers", event.query)
          .then(() => {
            that.filteredUsers = that.$store.getters["application/getUsers"];
          })
          .catch((error) => {
            this.$toast.add({
              severity: "error",
              summary: "Error while searching users",
              detail: error.response.data,
              life: 3000,
            });
          });
      }
    },

    saveApplication() {
      let that = this;
      that.validateFrom();
      that.submitted = true;
      let input = that.applicationDetails;
      if (this.form_error) {
        input.createdBy = this.$store.getters["login/getUsername"];
        input.createdDate = new Date();
        that.$store
          .dispatch("application/saveApplication", input)
          .then(() => {
            that.appDialog = false;
            that.blockedDocument = false;
            this.$toast.add({
              severity: "success",
              summary: this.toastsummary,
              life: 3000,
            });
            this.getCurrentPagedApplications();
          })
          .catch((error) => {
            this.$toast.add({
              severity: "error",
              summary: "Error while saving application",
              detail: error?.response?.data,
              life: 3000,
            });
            that.blockedDocument = false;
          });
      }
    },

    editApplication(application) {
      let that = this;
      let appDetails = _.clone(application);
      that.appDialog = true;
      appDetails.IsEditMode = true;
      this.IsEditMode = true;
      that.applicationDetails = appDetails;
     // that.applicationDetails.SkipApproval = appDetails.SkipApproval;
      this.appliedFilters = this.filters;
    },

    opendeleteDialog(application) {
      let that = this;
      let appDetails = application;
      appDetails.dialogContent = `Are you sure, you want to Deactivate the ${appDetails.name} ? `;
      appDetails.toastMsg = 'Deactivated'
      that.selectedApplication = _.clone(appDetails);
      that.deleteApp = true;
    },

    openundoDialog(application) {
      let that = this;
      let appDetails = application;
      appDetails.dialogContent = `Are you sure, you want to Activate the ${appDetails.name} ? `;
      appDetails.toastMsg = 'Activated'
      that.selectedApplication = _.clone(appDetails);
      that.deleteApp = true;
    },

    viewReviewersPublishers(application) {
      let that = this;
      let appDetails = _.clone(application);
      appDetails.dialogHeader = `Reviewers & Publishers of ${appDetails.name}`;
      that.selectedApplication = _.clone(appDetails);
      that.viewUsers = true;
    },

    updatestatus() {
      let that = this;
      let input = that.selectedApplication;
      input.isActive = !input.isActive;
      this.$store
        .dispatch("application/updatestatus", input)
        .then(() => {
          that.deleteApp = false;
          this.$toast.add({
            severity: "success",
            summary: that.selectedApplication.toastMsg + " Application",
            life: 1000,
          });
          that.getCurrentPagedApplications();
        })
        .catch((error) => {
          this.$toast.add({
            severity: "error",
            summary: "Error while updating the application",
            detail: error,
            life: 3000,
          });
        });
    },

    filterDate(value, filter) {
      if (
        filter === undefined ||
        filter === null ||
        (typeof filter === "string" && filter.trim() === "")
      ) {
        return true;
      }

      if (value === undefined || value === null) {
        return false;
      }
      value = moment(value).format("DD/MM/YYYY");
      filter = moment(filter).format("DD/MM/YYYY");
      return value === filter;
    },

    filterStatus(rowValue, filterValue) {
      if (filterValue == null) return rowValue || !rowValue;
      return filterValue == "Active" ? rowValue : !rowValue;
    },
    revalidatePublisher(){
      if(this.applicationDetails.publishers.length == 0){
        this.applicationDetails.publishers = null;
      }
    },
    revalidateReviewer(){
      if(this.applicationDetails.reviewers.length == 0){
        this.applicationDetails.reviewers = null;
      }
    },
    onSkipApproval(){
      if(this.applicationDetails.skipApproval){
        this.applicationDetails.reviewers = this.applicationDetails.reviewers ? this.applicationDetails.reviewers.length == 0 ? " " : this.applicationDetails.reviewers : null;
        this.applicationDetails.publishers = this.applicationDetails.publishers ? this.applicationDetails.publishers.length == 0 ? " " : this.applicationDetails.publishers : null;
      }
    }
  },
  props: {},
};
</script>
<style scoped>
.active {
  background-color: #c8e6c9 !important;
  color: #256029 !important;
  border: #c8e6c9 !important;
}
.p-button:hover {
  cursor: pointer !important;
}
</style>